import { WorkoutRetrieve } from 'types';
import { DistanceUnitEnum, ScoreTypeEnum, WeightUnitEnum } from 'types/enums';
import { getAlphabetLetterByIndex } from 'utils/functions';

import { inferSectionMode, isKeptBenchmarkSection } from '../../../forms/workoutBuilder/inferSectionMode';
import { WorkoutFormValues, WorkoutSectionData } from '../../../forms/workoutBuilder/types';

export function mapWorkoutToFormValues(workout: WorkoutRetrieve): WorkoutFormValues {
  return {
    name: workout.name,
    athleteNotes: workout.athleteNotes ?? '',
    coachNotes: workout.coachNotes ?? '',
    isVisibleToAthletes: workout.isVisibleToAthletes ?? false,
    sections: (workout.sections ?? []).map((sec, i): WorkoutSectionData => {
      const isSectionLevel = inferSectionMode(sec) === 'section_level';
      const kept = isKeptBenchmarkSection(sec);
      return {
        id: sec.workoutSectionId,
        letter: getAlphabetLetterByIndex(i),
        name: sec.name,
        description: sec.workoutInstructions ?? '',
        scoreEntireSection: isSectionLevel,
        saveAsBenchmark: isSectionLevel ? kept : true,
        levelScaled: sec.levelScaled,
        levelRx: sec.levelRx,
        levelRxPlus: sec.levelRxPlus,
        movements: (sec.movements ?? []).map((m, mi) => ({
          id: m.workoutSectionMovementId,
          // A one-off section-score movement is soft-deleted server-side, so its pk fails write
          // validation; clear it and let the save provision a fresh section-score movement.
          movementId: isSectionLevel && mi === 0 && !kept ? '' : m.workoutMovement?.workoutMovementId ?? '',
          movementName: m.workoutMovement?.name ?? m.workoutMovementName ?? '',
          scoreType: m.scoreType as ScoreTypeEnum,
          distanceUnit: (m.distanceUnit as DistanceUnitEnum | '' | null) || null,
          weightUnit: (m.weightUnit as WeightUnitEnum | '' | null) || null,
          scoreSets: (m.scoreSets ?? []).map(s => ({
            setIndex: s.setIndex,
            targetReps: s.targetReps,
          })),
        })),
      };
    }),
  };
}
